<div class="content-scroll-screen parent">
  <div class="col-lg-12 parent">
    <div class="row child">
      <p-card class="card-spacing-0">
        <span
          class="d-flex justify-content-between align-items-center m-3 globalborder-btm-header pb-2">
          <span class="col-auto">
            <h2 class="mb-0">Year Over Year (Beta)</h2>
          </span>
          <span class="d-flex gap-2 customizefilter-btn"> </span>
        </span>
        <div class="col-12">
          <div class="row m-2">
            <ng-container *ngIf="loggedInUserIsAdmin">
              <div class="col-3 fixed-width mb-4">
                <div class="form-group has-float-label">
                  <label class="form-label" for="bcSelectedId"
                    >Branding Consultant
                    <span class="madatory-field">*</span></label
                  >
                  <p-select
                    [showClear]="true"
                    [filter]="true"
                    [options]="bcList"
                    [(ngModel)]="bcSelectedId"
                    optionLabel="firstNameLastNamePersonalNumber"
                    optionValue="personnelNumber"
                    placeholder="Select Branding Consultant">
                    <ng-template let-item pTemplate="item">
                      {{
                        (item?.firstName || "") +
                          " " +
                          (item?.lastName || "") +
                          " " +
                          "(" +
                          item?.personnelNumber +
                          ")"
                      }}
                    </ng-template>
                  </p-select>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <div class="col-3 fixed-width mb-4">
                <div class="form-group has-float-label">
                  <label class="form-label" for="selectedYearRange">Year</label>
                  <p-select
                    [showClear]="true"
                    [filter]="true"
                    [options]="yearList"
                    [(ngModel)]="selectedYearRange"
                    optionLabel="name"
                    optionValue="name"
                    placeholder="Select Year Range">
                  </p-select>
                </div>
              </div>
            </ng-container>

            <div class="col-3 fixed-width-button mb-4">
              <div class="form-group has-float-label d-flex mt-4">
                <p-button
                  label="Filter"
                  (click)="onSubmit()"
                  [disabled]="filterDisabled()" />
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="col-lg-12 mt-3">
    <p-card class="card-spacing-0">
      <!-- <div></div> -->

      <div *ngIf="showReportSummaryGirds">
        <div class="row p-3">
          <div class="col-4 combinealltable">
            <div class="form-group has-float-label">
              <p-table
                id="myTable"
                #dt
                responsiveLayout="scroll"
                [value]="[[]]"
                styleClass="p-datatable-customers customcombinetable"
                [rowHover]="true"
                [autoLayout]="true"
                stripedRows
                [rowHover]="true"
                [rows]="20"
                [showCurrentPageReport]="true"
                scrollHeight="calc(100vh - 310px)"
                [size]="'small'"
                [paginator]="false"
                paginatorStyleClass="paginator-table"
                styleClass="table-listing"
                [resizableColumns]="false">
                <ng-template pTemplate="caption">
                  <h3 class="flex align-items-center justify-content-between">
                    Year Over Year
                  </h3>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr class="table-head">
                    <th></th>
                    <th class="text-center">Total Sell</th>
                    <th class="text-center">GP $</th>
                    <th class="text-center">GP %</th>
                    <th class="text-center">Growth %</th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-openClientCreditsDetailLists
                  let-rowIndex="rowIndex">
                  <tr>
                    <td class="text-center">{{ headers[0] }}</td>
                    <td class="text-center">
                      {{
                        revenueYear1Total | currency: "USD" : "symbol" : "0.2-2"
                      }}
                    </td>
                    <td class="text-center">
                      {{ GpYear1Total | currency: "USD" : "symbol" : "0.2-2" }}
                    </td>
                    <td class="text-center">
                      {{ GpPercentageYear1Total | number: "1.2-2" }}
                    </td>
                    <td class="text-center green-block">
                      <span *ngIf="GrowthPercentageYear1Total > 0">
                        {{ GrowthPercentageYear1Total | number: "1.2-2" }}
                      </span>
                      <span *ngIf="GrowthPercentageYear1Total <= 0">
                        {{ GrowthPercentageYear1Total | number: "1.2-2" }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-center">{{ headers[1] }}</td>
                    <td class="text-center">
                      {{
                        revenueYear2Total | currency: "USD" : "symbol" : "0.2-2"
                      }}
                    </td>
                    <td class="text-center">
                      {{ GpYear2Total | currency: "USD" : "symbol" : "0.2-2" }}
                    </td>
                    <td class="text-center">
                      {{ GpPercentageYear2Total | number: "1.2-2" }}
                    </td>
                    <td class="text-center green-block">
                      <span *ngIf="GrowthPercentageYear2Total > 0">
                        {{ GrowthPercentageYear2Total | number: "1.2-2" }}
                      </span>
                      <span *ngIf="GrowthPercentageYear2Total <= 0">
                        {{ GrowthPercentageYear2Total | number: "1.2-2" }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-center">{{ headers[2] }}</td>
                    <td class="text-center">
                      {{
                        revenueYear3Total | currency: "USD" : "symbol" : "0.2-2"
                      }}
                    </td>
                    <td class="text-center">
                      {{ GpYear3Total | currency: "USD" : "symbol" : "0.2-2" }}
                    </td>
                    <td class="text-center">
                      {{ GpPercentageYear3Total | number: "1.2-2" }}
                    </td>
                    <td></td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>

          <div class="col-3 combinealltable">
            <div class="form-group has-float-label">
              <p-table
                #dt
                responsiveLayout="scroll"
                [value]="[[]]"
                styleClass="p-datatable-customers customcombinetable"
                [rowHover]="true"
                [autoLayout]="true"
                stripedRows
                [rowHover]="true"
                [rows]="20"
                [showCurrentPageReport]="true"
                scrollHeight="calc(100vh - 310px)"
                [size]="'small'"
                [paginator]="false"
                paginatorStyleClass="paginator-table"
                styleClass="table-listing"
                [resizableColumns]="false">
                <ng-template pTemplate="caption">
                  <h3 class="flex align-items-center justify-content-between">
                    Tiger Status
                  </h3>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr class="table-head">
                    <th class="text-center">$Till Golden</th>
                    <th class="text-center">$Till Super</th>
                    <th class="text-center">$Till Mega</th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-openClientCreditsDetailLists
                  let-rowIndex="rowIndex">
                  <tr>
                    <td class="text-center">
                      <div
                        *ngIf="
                          GpYear1Total > (tigerDetails.goldenTigerFrom ?? 0);
                          then showgoldentiger;
                          else showgoldentigervalue
                        ">
                        here is ignored
                      </div>
                      <ng-template #showgoldentiger>
                        <img
                          src="../../../../../assets/images/running-tiger.gif"
                          class="instruction-image"
                          width="50px;"
                          alt="img" />
                      </ng-template>
                      <ng-template #showgoldentigervalue>{{
                        setTigerTargetValue(
                          tigerDetails.goldenTigerFrom ?? 0,
                          tigerDetails.goldenTigerTo ?? 0
                        ) | currency: "USD" : "symbol" : "0.2-2"
                      }}</ng-template>
                    </td>
                    <td class="text-center">
                      <div
                        *ngIf="
                          GpYear1Total > (tigerDetails.superTigerFrom ?? 0);
                          then showsupertiger;
                          else showsupertigervalue
                        "></div>

                      <ng-template #showsupertiger>
                        <img
                          src="../../../../../assets/images/running-tiger.gif"
                          class="instruction-image"
                          width="50px;"
                          alt="img" /><br />
                        <img
                          src="../../../../../assets/images/running-tiger.gif"
                          class="instruction-image"
                          width="50px;"
                          alt="img" />
                      </ng-template>

                      <ng-template #showsupertigervalue>{{
                        setTigerTargetValue(
                          tigerDetails?.superTigerFrom ?? 0,
                          tigerDetails?.superTigerTo ?? 0
                        ) | currency: "USD" : "symbol" : "0.2-2"
                      }}</ng-template>
                    </td>
                    <td class="text-center">
                      <div
                        *ngIf="
                          GpYear1Total > (tigerDetails.megaTigerFrom ?? 0);
                          then showmegatiger;
                          else showsmegatigervalue
                        "></div>
                      <ng-template #showmegatiger>
                        <img
                          *
                          src="../../../../../assets/images/running-tiger.gif"
                          class="instruction-image"
                          width="50px;"
                          alt="img" />
                        <img
                          src="../../../../../assets/images/running-tiger.gif"
                          class="instruction-image"
                          width="50px;"
                          alt="img" /><br />
                        <img
                          src="../../../../../assets/images/running-tiger.gif"
                          class="instruction-image"
                          width="50px;"
                          alt="img" />
                        <img
                          src="../../../../../assets/images/running-tiger.gif"
                          class="instruction-image"
                          width="50px;"
                          alt="img" />
                      </ng-template>
                      <ng-template #showsmegatigervalue>{{
                        setTigerTargetValue(
                          tigerDetails?.megaTigerFrom ?? 0,
                          tigerDetails?.megaTigerTo ?? 0
                        ) | currency: "USD" : "symbol" : "0.2-2"
                      }}</ng-template>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>

          <div class="col-2 combinealltable">
            <div class="form-group has-float-label">
              <p-table
                #dt
                responsiveLayout="scroll"
                [value]="[[]]"
                styleClass="p-datatable-customers customcombinetable"
                [rowHover]="true"
                [autoLayout]="true"
                stripedRows
                [rowHover]="true"
                [rows]="20"
                [showCurrentPageReport]="true"
                scrollHeight="calc(100vh - 310px)"
                [size]="'small'"
                [paginator]="false"
                paginatorStyleClass="paginator-table"
                styleClass="table-listing"
                [resizableColumns]="false">
                <ng-template pTemplate="caption">
                  <h3 class="flex align-items-center justify-content-between">
                    FY Unbilled GP
                  </h3>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr class="table-head">
                    <th></th>
                  </tr>
                  <tr>
                    <th style="padding-bottom: 0.75rem"></th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-openClientCreditsDetailLists
                  let-rowIndex="rowIndex">
                  <tr>
                    <td class="text-center">
                      {{
                        reportData?.fyUnbilledGP
                          | currency: "USD" : "symbol" : "0.2-2"
                      }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>

          <div class="col-3 combinealltable">
            <div class="form-group has-float-label">
              <p-table
                #dt
                responsiveLayout="scroll"
                [value]="[[]]"
                styleClass="p-datatable-customers customcombinetable"
                [rowHover]="true"
                [autoLayout]="true"
                stripedRows
                [rowHover]="true"
                [rows]="20"
                [showCurrentPageReport]="true"
                scrollHeight="calc(100vh - 310px)"
                [size]="'small'"
                [paginator]="false"
                paginatorStyleClass="paginator-table"
                styleClass="table-listing"
                [resizableColumns]="false">
                <ng-template pTemplate="caption">
                  <h3 class="flex align-items-center justify-content-between">
                    Backlog
                  </h3>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr class="table-head">
                    <th class="text-center">Total Sell</th>
                    <th class="text-center">GP$</th>
                    <th class="text-center">GP %</th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-openClientCreditsDetailLists
                  let-rowIndex="rowIndex">
                  <tr>
                    <td class="text-center">
                      {{
                        reportData?.backlogTotalSell
                          | currency: "USD" : "symbol" : "0.2-2"
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        reportData?.backlogTotalGp
                          | currency: "USD" : "symbol" : "0.2-2"
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        reportData?.backlogTotalGpPercentage
                          | currency: "USD" : "symbol" : "0.2-2"
                      }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-between align-items-center m-3 pb-2"
        *ngIf="showReportsRadioButtons">
        <div class="field-wrap ms-2 d-flex">
          <div
            class="form-group d-flex align-center justify-content-between gap-2">
            <div class="d-flex gap-2 align-items-center">
              <p-radiobutton
                id="ByMonth"
                value="ByMonth"
                name="radio"
                [disabled]="filterDisabled()"
                [(ngModel)]="selectedRadioButton"
                (onClick)="getYearToYearReportByFilter('ByMonth')" />
              <label class="mt-1">By Month</label>
            </div>

            <div class="d-flex gap-2 align-items-center">
              <p-radiobutton
                id="ByClient"
                value="ByClient"
                name="radio"
                [disabled]="filterDisabled()"
                [(ngModel)]="selectedRadioButton"
                (onClick)="getYearToYearReportByFilter('ByClient')" />
              <label class="mt-1">By Client</label>
            </div>
          </div>
        </div>
        <div>
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
        </div>
      </div>

      <div class="mt-4" *ngIf="showReportByMonth">
        <p-table
          #dt
          [value]="clientReportData"
          styleClass="p-datatable-customers ordersListing"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="false"
          [filterDelay]="0"
          stripedRows
          scrollHeight="calc(100vh - 600px)"
          [size]="'small'"
          paginatorStyleClass="paginator-table"
          sortMode="multiple">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th class="number"></th>
              <th class="status"></th>
              <th></th>
              <ng-container *ngFor="let header of headers">
                <th colspan="4" style="text-align: center" class="table-head">
                  {{ header }}
                </th>
              </ng-container>
            </tr>
            <tr class="customstickyheaderfilter">
              <th class="text-center">Id</th>
              <th class="text-center">Name</th>
              <th class="text-center">Fiscal</th>
              <!-- Dynamic subheaders -->
              <ng-container *ngFor="let header of headers; index as i">
                <th class="text-center">Revenue</th>
                <th class="text-center">GP $</th>
                <th class="text-center">GP %</th>
                <th *ngIf="i !== 2" class="text-center">Growth %</th>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="rowData"
              [pSelectableRowIndex]="rowIndex">
              <td class="text-center">
                <span *ngIf="rowIndex === 0">{{ rowData?.bcId }}</span>
              </td>
              <td class="text-center">
                <span *ngIf="rowIndex === 0">{{ rowData?.bcName }}</span>
              </td>
              <td class="currency text-center">{{ rowData?.fiscalMonth }}</td>
              <td class="text-end">
                <span
                  [style.background-color]="
                    rowData?.isBacklog === true ? 'var(--p-yellow-400)' : null
                  "
                  >{{
                    rowData?.revenueYear1 | currency: "USD" : "symbol" : "0.2-2"
                  }}</span
                >
              </td>
              <td class="text-end">
                {{ rowData?.gpYear1 | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ rowData?.gpPercentageYear1 | number: "1.2-2" }}
              </td>
              <td class="text-end green-block">
                <span *ngIf="rowData?.growthPercentageYear1 > 0">
                  {{ rowData?.growthPercentageYear1 | number: "1.2-2" }}
                </span>
                <span *ngIf="rowData?.growthPercentageYear1 <= 0">
                  {{ rowData?.growthPercentageYear1 | number: "1.2-2" }}
                </span>
              </td>
              <td class="text-end">
                {{
                  rowData?.revenueYear2 | currency: "USD" : "symbol" : "0.2-2"
                }}
              </td>
              <td class="text-end">
                {{ rowData?.gpYear2 | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ rowData?.gpPercentageYear2 | number: "1.2-2" }}
              </td>
              <td class="text-end green-block">
                <span *ngIf="rowData?.growthPercentageYear2 > 0">
                  {{ rowData?.growthPercentageYear2 | number: "1.2-2" }}
                </span>
                <span *ngIf="rowData?.growthPercentageYear2 <= 0">
                  {{ rowData?.growthPercentageYear2 | number: "1.2-2" }}
                </span>
              </td>
              <td class="text-end">
                {{
                  rowData?.revenueYear3 | currency: "USD" : "symbol" : "0.2-2"
                }}
              </td>
              <td class="text-end">
                {{ rowData?.gpYear3 | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ rowData?.gpPercentageYear3 | number: "1.2-2" }}
              </td>
              <!-- <td class="text-right">
            {{rowData?.growthPercentageYear3 | number: '1.2-2'}}
          </td> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No record found.</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td class="text-end">Totals</td>
              <td></td>
              <td class="currency text-end"></td>
              <td class="text-end">
                {{ revenueYear1Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpYear1Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpPercentageYear1Total | number: "1.2-2" }}
              </td>
              <td class="text-end">
                {{ GrowthPercentageYear1Total | number: "1.2-2" }}
              </td>
              <td class="text-end">
                {{ revenueYear2Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpYear2Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpPercentageYear2Total | number: "1.2-2" }}
              </td>
              <td class="text-end">
                {{ GrowthPercentageYear2Total | number: "1.2-2" }}
              </td>
              <td class="text-end">
                {{ revenueYear3Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpYear3Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpPercentageYear3Total | number: "1.2-2" }}
              </td>
              <!-- <td class="text-right">
              {{GrowthPercentageYear3Total | number: '1.2-2'}}
            </td> -->
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="mt-4" *ngIf="showReportByClient">
        <p-table
          #dt
          [value]="clientReportData"
          styleClass="p-datatable-customers ordersListing"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="true"
          stripedRows
          [showCurrentPageReport]="true"
          scrollHeight="calc(100vh - 700px)"
          [size]="'small'"
          paginatorStyleClass="paginator-table"
          styleClass="table-listing"
          [filterDelay]="0"
          sortMode="multiple">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th style="width: 3rem" class="number"></th>
              <th class="status"></th>
              <th></th>
              <th></th>
              <ng-container *ngFor="let header of headers">
                <th colspan="3" style="text-align: center">{{ header }}</th>
              </ng-container>
            </tr>
            <tr class="customstickyheaderfilter">
              <th class="text-center">Id</th>
              <th class="text-center">Name</th>
              <th>Client Account</th>
              <th>Client Id</th>
              <!-- Dynamic subheaders -->
              <ng-container *ngFor="let header of headers; index as i">
                <th
                  class="text-center"
                  pSortableColumn="{{ setSortableColumn(i) }}">
                  Revenue
                  <p-sortIcon field="{{ setSortableColumn(i) }}"></p-sortIcon>
                </th>
                <th class="text-center">GP $</th>
                <th class="text-center">GP %</th>
              </ng-container>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th>
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="clientName"
                  id="clientName"
                  style="max-width: 200px"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'clientName',
                      'contains'
                    )
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component text-center" />
              </th>
              <th>
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="clientId"
                  id="clientId"
                  (input)="
                    dt.filter($any($event.target).value, 'clientId', 'contains')
                  "
                  placeholder=""
                  class="" />
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="rowData"
              [pSelectableRowIndex]="rowIndex">
              <td class="text-center">
                <span *ngIf="rowIndex === 0">{{ rowData?.bcId }}</span>
              </td>
              <td class="text-center">
                <span *ngIf="rowIndex === 0">{{ rowData?.bcName }}</span>
              </td>
              <td class="currency">{{ rowData?.clientName }}</td>
              <td class="currency">{{ rowData?.clientId }}</td>
              <td class="text-end">
                <span
                  [style.background-color]="
                    rowData?.isBacklog === true ? 'var(--p-yellow-400)' : null
                  "
                  >{{
                    rowData?.revenueYear1 | currency: "USD" : "symbol" : "0.2-2"
                  }}</span
                >
              </td>
              <td class="text-end">
                {{ rowData?.gpYear1 | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ rowData?.gpPercentageYear1 | number: "1.2-2" }}
              </td>

              <td class="text-end">
                {{
                  rowData?.revenueYear2 | currency: "USD" : "symbol" : "0.2-2"
                }}
              </td>
              <td class="text-end">
                {{ rowData?.gpYear2 | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ rowData?.gpPercentageYear2 | number: "1.2-2" }}
              </td>

              <td class="text-end">
                {{
                  rowData?.revenueYear3 | currency: "USD" : "symbol" : "0.2-2"
                }}
              </td>
              <td class="text-end">
                {{ rowData?.gpYear3 | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ rowData?.gpPercentageYear3 | number: "1.2-2" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No record found.</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td class="text-end">Totals</td>
              <td></td>
              <td></td>
              <td class="currency text-end"></td>
              <td class="text-end">
                {{ revenueYear1Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpYear1Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpPercentageYear1Total | number: "1.2-2" }}
              </td>
              <td class="text-end">
                {{ revenueYear2Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpYear2Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpPercentageYear2Total | number: "1.2-2" }}
              </td>
              <td class="text-end">
                {{ revenueYear3Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpYear3Total | currency: "USD" : "symbol" : "0.2-2" }}
              </td>
              <td class="text-end">
                {{ GpPercentageYear3Total | number: "1.2-2" }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
